module.exports = __webpack_public_path__ + "img/flat-unlock-button-honda.a196ca06.png";